import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import * as Sentry from '@sentry/angular';
import { SentryHelper, provideBirdz } from '@web/birdz-angular';
import { routes } from 'app/app.routes';
import { provideHighcharts } from 'highcharts-angular';
import { AppComponent } from './app/components/app/app.component';
import { environment as env } from './environments/environment';

Sentry.init({
  denyUrls: [/^https?:\/\/[a-zA-Z0-9-]*\.ew\.r\.appspot\.com/],
  environment: env.env,
  dsn: env.sentryDSN,
  beforeSend: SentryHelper.beforeSend,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  tracePropagationTargets: env.sentryTracingOrigins,
  tracesSampleRate: env.sentryTracesSampleRate,
});
Sentry.setTag('bapp', 'supervision');

if (env.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserAnimationsModule),
    provideRouter(routes),
    provideBirdz({
      env: env.env,
      apiUrl: env.apiUrl,
      showEnv: true,
      notifications: {
        url: env.notificationsUrl,
        cookiesDomain: env.notificationsCookiesDomain,
      },
      map: {
        mapboxAccessToken: env.mapboxAccessToken,
      },
      auth: {
        loginUrl: env.loginUrl,
        loginUrlSilent: env.loginUrlSilent,
        logoutUrl: env.logoutUrl,
        bypassOAuth: env.bypassOAuth,
      },
      errorHandler: Sentry.createErrorHandler({
        showDialog: false,
        extractor: SentryHelper.extractor,
      }),
    }),
    provideHighcharts({
      modules: () => [import('highcharts/esm/modules/no-data-to-display')],
    }),
    provideTranslocoMessageformat(),
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => {
  console.error(err); // eslint-disable-line
});
